export default __webpack_public_path__ + "static/media/fanatik333.398a3701.png";